// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';

// Material UI ( mui ) components
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
// Section for import custom components --------------------------------------------------------------------------------

// Section for render component ----------------------------------------------------------------------------------------

// Section for type definition -----------------------------------------------------------------------------------------
import PickupReviewPropsData from '@/types/components/MansionDetail/PickupReviewPropsData';

type PickupReviewProps = {
  pickupReview: PickupReviewPropsData[];
};

export default function PickupReview(props: PickupReviewProps) {
  const { pickupReview } = props;
  return (
    <Box id="app-content-detail-features" className="py-2 max-md:py-1">
      <Container className="md:max-w-7xl md:w-full md:mx-auto md:px-24">
        <Box className="px-10 max-md:px-4 py-6 max-md:py-5 bg-gray-01 rounded-lg">
          <Box className="flex justify-center items-center gap-3 h-9 mb-6 rounded-lg balloon">
            <Typography
              component="h3"
              variant="h3"
              className="text-base text-rf-blue font-bold text-center leading-relaxed max-md:leading-[22px] tracking-wide"
            >
              このマンションの口コミは・・・
            </Typography>
          </Box>
          <Box className="mt-5 mx-auto flex flex-col gap-y-4">
            {pickupReview.map((pickupReviewData) => (
              <Link
                key={pickupReviewData.key}
                href={`#${pickupReviewData.href_id}`}
                className="flex gap-x-4 max-md:gap-x-2  text-lg max-md:text-base"
              >
                <Box>
                  <CheckRoundedIcon className="text-rf-black" />
                </Box>
                <Typography className="pt-1 text-base max-md:text-sm text-rf-blue underline">
                  {pickupReviewData.text}
                </Typography>
              </Link>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
